module.exports = __webpack_public_path__ + "static/media/glasschain-qa-logo.c24e2e04.png";